import { RegexConfig } from "../RegexConfig";

export const addQuesionValidationConfig = {
  firstName: {
    required: true,
    pattern: RegexConfig.name,
    minLength: 2,
    maxLength: 20,
    errorMessage: {
      required: "*Required",
      length: "*Must be between 2 to 20 characters",
    },
  },
  lastName: {
    required: false,
    pattern: RegexConfig.name,
    minLength: 2,
    maxLength: 20,
    errorMessage: {
      length: "*Must be between 2 to 20 characters",
    },
  },
  // preferredCommunication: {
  //   required: true,
  //   errorMessage: {
  //     required: "*Required",
  //   },
  // },
  email: {
    required: true,
    pattern: RegexConfig.email,
    errorMessage: {
      required: "*Required",
      pattern: "*Please enter a valid email",
    },
  },
  phone: {
    required: false,
    pattern: RegexConfig.phone,
    errorMessage: {
      pattern: "*Please enter a valid 10-digit phone number",
    },
  },
  // zipcode: {
  //   required: true,
  //   errorMessage: {
  //     required: "*Required",
  //   },
  // },
  // bestTime: {
  //   required: true,
  //   errorMessage: {
  //     required: "*Required",
  //   },
  // },
  // service: {
  //   required: true,
  //   errorMessage: {
  //     required: "*Required",
  //   },
  // },
  question: {
    required: true,
    minLength: 1,
    maxLength: 200,
    errorMessage: {
      required: "*Required",
      length: "*Must be between 1 to 200 characters",
    },
  },
};
